/**
 * You can register global directives here and use them as a plugin in your main Vue instance
 */
export default defineNuxtPlugin((nuxtApp) => {
    nuxtApp.vueApp.directive('store-focus', {});
})
